export { default } from "./envelopes-triangular"
